import {
    SHOW_PERMIT_LIST_VIEW,
    showPermitsListViewAction,
    showPermitsBatchListViewAction,
    SHOW_PERMIT_BATCH_LIST_VIEW
} from "./types";
import { createAction } from "@reduxjs/toolkit";

export const showPermitsListView =
    createAction<showPermitsListViewAction["payload"]>(SHOW_PERMIT_LIST_VIEW);
export const showPermitsBatchListView = createAction<showPermitsBatchListViewAction["payload"]>(
    SHOW_PERMIT_BATCH_LIST_VIEW
);
